import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  activeAbsolute: {
    position: 'absolute',
    height: 'calc(100% - 130px)',
    width: 'calc(100% - 316px)',
    overflow: 'auto',
    padding: theme.spacing(1),

    [theme.breakpoints.down('lg')]: {
      paddingLeft: '0',
      paddingRight: '0',
      width: '100%',
      height: (p) => p.height || window.innerHeight - 194,
    },
    [theme.breakpoints.down('md')]: {
      position: 'relative',
      height: '100%',
      overflow: undefined,
    },

    '@media print': {
      position: 'relative',
      width: '100%',
      height: '100%',
    },
  },
  active: {
    padding: theme.spacing(1),
    textAlign: 'center',
    [theme.breakpoints.down('lg')]: {
      paddingLeft: '0',
      paddingRight: '0',
    },
    [theme.breakpoints.down('md')]: {
      position: 'relative',
      width: '100%',
      height: '100%',
      overflow: undefined,
    },
    '& > div': {
      textAlign: 'initial',
    },
  },
}));

export default function TabContainer(props) {
  const classes = useStyles(props);

  return (
    <div id="ActiveAbsolute" className={props.useAbsolute ? classes.activeAbsolute : classes.active}>
      {props.children}
    </div>
  );
}
